import React, { useContext } from 'react'
import { FormLayoutRow } from '@pushly/aqe/lib/components'
import { Input } from 'antd'
import { PromptVisitorConditions } from '@pushly/models/lib/structs/prompts/prompt-visitor-conditions'
import { DEFAULT_SESSION_PAGE_VIEWS } from '../../constants'
import { PromptEditorContext } from '../../context'

type Props = {
    value: PromptVisitorConditions | undefined
    onChange: (update: PromptVisitorConditions) => void
}

export const SessionPageViewsConditionEditor: React.FC<Props> = ({ value, onChange }) => {
    const { loading, selectedPromptIdx } = useContext(PromptEditorContext)

    return (
        <FormLayoutRow
            loading={loading}
            layout="vertical"
            label={null}
            value={
                !loading && (
                    <Input
                        key={selectedPromptIdx}
                        placeholder="0"
                        addonAfter="pages viewed"
                        className="vc-pages-viewed"
                        type="number"
                        min={0}
                        defaultValue={value?.sessionPageViews ?? DEFAULT_SESSION_PAGE_VIEWS}
                        onChange={(ev) => {
                            onChange(
                                PromptVisitorConditions.from({
                                    sessionPageViews: parseInt(ev.target.value, 10),
                                }),
                            )
                        }}
                    />
                )
            }
        />
    )
}
